import { render, staticRenderFns } from "./TopBg.vue?vue&type=template&id=6720ec3f&"
import script from "./TopBg.vue?vue&type=script&lang=js&"
export * from "./TopBg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports